import template from './calendar.html';
import controller from './calendar.controller';
import './calendar.scss';

let calendarComponent = {
  restrict: 'E',
  bindings: {
    date: '<',
    selectDay: '&',
    filters: '<',
    user: '<',
    isInception: '<',
    isMobileApp: '<',
    dateToday: '<',
    onClickPrevious: '&',
    onClickNext: '&'
  },
  template,
  controller
};

export default calendarComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendar/calendar.component.js